import { baseData } from './accountHelper'
import { formatDate } from './formate'
import { CouponType } from './coupon'

export const isUserFree = accountState =>
	!accountState || Number(accountState) === 1

export const isUserFrozen = accountState => Number(accountState) === 6

export const isUserExpired = (accountState, expiredDate) =>
	!isUserFree(accountState) && expiredDate < new Date().getTime()

// 选择版本
export const getVersionSelected = (version = 'pro') => baseData[version]

// 选择时间
export const getTimeSelected = (version, plan) =>
	getVersionSelected(version)[{ 1: 'month', 6: 'halfYear', 12: 'year' }[plan]]

// 已过期且选择12个月的非免费用户免除数据保管费
export const isReserveFeeRequired = (accountState, expiredDate, plan) =>
	isUserExpired(accountState, expiredDate) && plan !== 12

// 金额精度计算
export const limitDigits = (number, digits) => {
	return Number(number.toFixed(digits))
}

// 计算总金额
export const calculateCoupon = (coupon, currentSelect) => {
	// 无优惠或者优惠不可用, 返回当前选择价格
	const total = Number(currentSelect.total)
	if (!coupon || coupon.isCouponInvalid) return total
	const { fee_abs, fee_pct, lower_bound, coupon_type } = coupon

	// 赠送时长
	if (coupon_type === CouponType.exp_mon) {
		return total
	} else if (coupon_type === CouponType.fee_abs) {
		// 减免金额
		const totalFee = (total * 10000 - (Number(fee_abs) * 10000) / 100) / 10000
		return totalFee >= lower_bound / 100 ? totalFee : total
	} else {
		// 折扣
		const totalFee = (Number(fee_pct) * total) / 100
		return totalFee >= lower_bound / 100 ? totalFee : total
	}
}

// web端优惠文字 0代表百分比单位% 1代表价格优惠单位/分 2代表赠送月份
export const getCouponTextInWeb = (coupon, currentSelect) => {
	if (!coupon || coupon.isCouponInvalid) return null
	const { exp_mon, fee_abs, fee_pct, coupon_type } = coupon
	switch (coupon_type) {
		case CouponType.fee_pct:
			let count =
				Constants['LOCAL_LANGUAGE'] === 'zh' ? fee_pct / 10 : 100 - fee_pct
			return Constants['PRICING_NEW_DETAIL_PROMOTE_DISCOUT'].replace(
				'%s',
				limitDigits(count, 1),
			)
		case CouponType.fee_abs:
			return Constants['PRICING_NEW_DETAIL_PROMOTE_DEC'].replace(
				'%s',
				limitDigits(fee_abs / 100, 2),
			)
		case CouponType.exp_mon:
			const time =
				Number(currentSelect.expried) + exp_mon * 30 * 24 * 3600 * 1000
			const expriedTime = formatDate(time)

			return Constants['PRICING_NEW_DETAIL_PROMOTE_TIME']
				.replace('%d', exp_mon)
				.replace('%s', expriedTime)
		default:
			return ''
	}
}

/**
 * 优惠码是否在当前选择版本下不可用
 * 正常情况返回false
 * 由于最小金额或月份lower_bound限制,在选择某一个版本时，金额或者时间小于lower_bound,此时返回true
 */
/**
 * @param {Object} PaidOption
 * @param {Object} PaidOption.coupon 优惠码信息
 * @param {number | string} PaidOption.timeType 当前选择的时长
 * @param {string} PaidOption.version 当前选择的版本
 * @param {Object} PaidOption.versionData pricing页面支付信息
 * @return {boolean}
 */

export const getIfPaidInvalid = ({
	coupon,
	timeType,
	version,
	versionData,
}) => {
	if (!coupon) return
	const currentVersion = versionData || getVersionSelected(version)
	const timeTypeWidthKey = {
		12: 'year',
		6: 'halfYear',
		1: 'month',
	}
	const currentPaid = currentVersion[timeTypeWidthKey[timeType]]
	if (coupon.coupon_type === CouponType.exp_mon) {
		return timeType < coupon.lower_bound
	}

	return (
		calculateCoupon(coupon, { total: currentPaid.total }) <= coupon.lower_bound
	)
}
